import React from "react";
import {
  Tabs,
  Tab,
  Box,
  Paper,
  useTheme,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockResetIcon from "@mui/icons-material/LockReset";
import BusinessAccount from "./businessAccount";
import BusinessChangePassword from "./changePassword";
import {getLoginUserData} from "../../../services/account.service";
import Loader from "../../../common/loader";

const BusinessProfile: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [businessId, setBusinessId] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const theme = useTheme();

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

    React.useEffect(() => {
      const init = async () => {
        try {
          setLoading(true);
          const user = await getLoginUserData();
          if (user?.id) setBusinessId(user.id);
        } catch {
          console.error("Failed to load user data");
        }finally {
          setLoading(false);
        }
      };
      init();
    }, []);

  if (loading) return <Loader />;
  return (
    <div className="flex justify-center items-start min-h-screen">
      <Paper elevation={4} className="w-full md:mx-4 sm:mx-1 lg:mx-8 rounded-2xl shadow-md p-4 sm:p-6">
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          centered
          sx={{
            borderRadius: "12px",
            backgroundColor: theme.palette.grey[100],
            mb: 2,
            "& .MuiTabs-indicator": {
              height: "3px",
              borderRadius: "3px",
            },
          }}
        >
          <Tab
            icon={<AccountCircleIcon />}
            iconPosition="start"
            label={
              <span className="hidden sm:inline">Update Profile</span>
            }
            sx={{
              fontWeight: 600,
              color: activeTab === 0 ? theme.palette.primary.main : "inherit",
              transition: "all 0.3s",
              minHeight: { xs: 48, sm: 64 },
            }}
          />
          <Tab
            icon={<LockResetIcon />}
            iconPosition="start"
            label={
              <span className="hidden sm:inline">Change Password</span>
            }
            sx={{
              fontWeight: 600,
              color: activeTab === 1 ? theme.palette.primary.main : "inherit",
              transition: "all 0.3s",
              minHeight: { xs: 48, sm: 64 },
            }}
          />
        </Tabs>
        
        <Box className="mt-6 transition-all duration-300 ease-in-out">
          {activeTab === 0 && <BusinessAccount businessId={businessId}/>}
          {activeTab === 1 && <BusinessChangePassword businessId={businessId}/>}
        </Box>
      </Paper>
    </div>
  );
};

export default BusinessProfile;
